import React, { useEffect, useState } from "react";
import SurveyTitle from "../SurveyTitleV2";
import SurveyFooter from "../SurveyFooter";
import dayjs from "dayjs";
import { useTranslation } from "next-i18next";
import { AnswerQuestionModel } from "@/interfaces/surveyTypes";
import { answerQuestions } from "@/hooks/useRequest/useSurveyRequest";
import RFDatePicker from "@/containers/common/date-picker";

import log2sensors, { SensorsEventIds } from "@/utils/log2sensors";
import ContentContainer from "@/containers/common/ContentContainer";

interface BirthdayProps {
	answerFieldToValueMap: Map<string, string>;
	questionFieldToIdMap: Map<string, string>;
	onNextClick: () => void;
}

function Birthday(props: BirthdayProps) {
	const { t } = useTranslation("survey");
	const [birthday, setBirthday] = useState("1990-01-01");
	const [errorValidate, setErrorValidate] = useState(true);
	const [isFocus, setIsFocus] = useState(false);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		const birthdayValue = props.answerFieldToValueMap.get("birthday");
		if (!birthdayValue) return;
		setBirthday(birthdayValue);
	}, [props.answerFieldToValueMap]);

	const handleConfirm = async () => {
		const validate = validate18years(birthday);
		setErrorValidate(validate);
		setIsFocus(true);
		if (!validate) return;

		try {
			if (birthday === undefined) return;
			const birthdayQuestionId = props.questionFieldToIdMap.get("birthday");
			if (!birthdayQuestionId) {
				throw Error("missing birthday questionId");
			}

			const payload: AnswerQuestionModel[] = [
				{
					answer: birthday,
					questionId: birthdayQuestionId,
				},
			];

			setLoading(true);
			await answerQuestions({ payload });
			props.onNextClick();
		} catch (error) {
			console.log(error);
		} finally {
			setLoading(false);
			log2sensors(SensorsEventIds.AO_BIRTHDAY_NEXTPAGE);
		}
	};

	const validate18years = (_value: string) => {
		if (!_value) {
			return false;
		}
		const _validate18 = dayjs().add(-18, "y").valueOf();
		return dayjs(_value).valueOf() <= _validate18;
	};

	useEffect(() => {
		log2sensors(SensorsEventIds.AO_BIRTHDAY_VIEW);
	}, []);

	return (
		<ContentContainer
			className="px-4.5"
			animation
			header={
				<SurveyTitle
					title={t("when-is-your-birthday")}
					subtitle={t("your-date-of-birth-should-match-the-ID-proof-you-upload")}
				/>
			}
			footer={
				<SurveyFooter
					loading={loading}
					onNextBtnClick={handleConfirm}
					onPrivacyClick={() => log2sensors(SensorsEventIds.AO_BIRTHDAY_PRAVICY)}
					onSecureClick={() => log2sensors(SensorsEventIds.AO_BIRTHDAY_SECURITY)}
				/>
			}
		>
			<div className="h-12" />

			<RFDatePicker
				defaultValue={birthday}
				onChange={(e) => {
					setBirthday(e);
					log2sensors(SensorsEventIds.AO_BIRTHDAY_BIRTHDAY);
				}}
			/>

			{!errorValidate && isFocus ? (
				<p style={{ color: "var(--rf-color-error)" }} className="mt-4 text-xs ">
					{t("at-least-18-years-old")}
				</p>
			) : null}
		</ContentContainer>
	);
}

export default Birthday;
